import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { closeGuestSheet, openGuestSheet } from '../../store/slices/uiSlice';
import { useSignOut } from '../../hooks/useSignOut';
import GuestSignOutSheet from './GuestSignOutSheet';
import SaveAccountSheet from './SaveAccountSheet';

/**
 * The two guest sheets, mounted once in `App` (inside the toast provider and
 * the router). Anything can open them with `openGuestSheet('save' | 'signout')`.
 */
export default function GuestSheets() {
  const dispatch = useAppDispatch();
  const sheet = useAppSelector(state => state.ui.guestSheet);
  const isGuest = useAppSelector(state => state.auth.user?.is_guest === true);
  const { performSignOut } = useSignOut();

  const close = () => {
    dispatch(closeGuestSheet());
  };

  return (
    <>
      <SaveAccountSheet open={isGuest && sheet === 'save'} onClose={close} />
      <GuestSignOutSheet
        open={isGuest && sheet === 'signout'}
        onClose={close}
        onSaveAccount={() => {
          dispatch(openGuestSheet('save'));
        }}
        onSignOut={async () => {
          close();
          await performSignOut();
        }}
      />
    </>
  );
}
